import SearchIconBlack from "@assets/images/search-mini.svg";
import { Button, Grid, Popover } from "@material-ui/core";
import DataSortTable from "@saleor/components/DataSortTable";
import SingleTextField from "@saleor/components/SingleTextField";
import { useGetPlantsByMatCodeLazyQuery } from "@saleor/graphql";
import React, { useCallback, useEffect, useState } from "react";
import InlineSVG from "react-inlinesvg/esm";
import { FormattedMessage } from "react-intl";

function ModalSearchForPlants({ row, col, classes, handleChange }) {
  const [plant, setPlant] = useState<string>("");
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setPlant(row[col.id]);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [getPlantsData, { data: plantsCodes }] = useGetPlantsByMatCodeLazyQuery(
    {
      variables: {
        materialCode: row?.materialCode
      }
    }
  );

  useEffect(() => {
    if (open) {
      getPlantsData();
    }
  }, [open]);

  const rows = plantsCodes?.getPlantsByMatCode?.map(plantsCode => ({
    PlantCode: plantsCode.plantCode,
    address: plantsCode.plantCode,
    PlantName: plantsCode.plantName
  }));

  const handleRowSelection = useCallback(
    selectedRowIndex => {
      if (plantsCodes?.getPlantsByMatCode[selectedRowIndex]) {
        const a = plantsCodes.getPlantsByMatCode[selectedRowIndex];
        if (plant === a.plantCode) {
          setPlant("");
        } else {
          setPlant(a.plantCode);
        }
      }
    },
    [plantsCodes, plant, setPlant]
  );

  const columns = [
    { field: "PlantCode", headerName: "Plant Code", width: 90 },
    { field: "PlantName", headerName: "Plant Name", width: 200 }
  ];

  const handleSubmit = () => {
    handleChange({
      target: { name: `lines[${row?.indexNumber}].${col.id}`, value: plant }
    });
    handleClose();
  };
  useEffect(() => {
    setPlant(row[col.id]);
  }, [row[col.id]]);

  if (!row && !col) {
    return null;
  }

  return (
    <Grid container style={{ position: "relative" }}>
      <SingleTextField
        id={`lines[${row?.indexNumber}].${col.id}Field`}
        name={`lines[${row?.indexNumber}].${col.id}`}
        value={row[col.id]}
        readOnly
        onChange={() => null}
      />
      <Button
        id={`plantSearch${row?.indexNumber}`}
        variant={"contained"}
        color={"secondary"}
        className={classes.btnSearch}
        onClick={handleClick}
        aria-describedby={id}
      >
        <InlineSVG src={SearchIconBlack} width={24} height={24} />
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <div className={classes.searchPlantWrapper}>
          <DataSortTable
            selected={plant}
            headCells={columns}
            onRowSelect={handleRowSelection}
            rows={rows}
            sortField="PlantCode"
            boldFields={["PlantCode", "partnerName"]}
          />
          <div className={classes.btnWrapper}>
            <Button
              id={`plantCloseModal${row?.indexNumber}`}
              variant={"outlined"}
              color={"secondary"}
              className={classes.buttonCancel}
              onClick={handleClose}
            >
              <FormattedMessage defaultMessage={"Cancel"} />
            </Button>
            <Button
              id={`plantSubmitModal${row?.indexNumber}`}
              variant={"contained"}
              color={"secondary"}
              className={classes.buttonConfirm}
              onClick={handleSubmit}
            >
              <FormattedMessage defaultMessage={"Submit"} />
            </Button>
          </div>
        </div>
      </Popover>
    </Grid>
  );
}

export default ModalSearchForPlants;
